let sequence = 0;

/**
 * Local key for a conversation turn, used until (and alongside) any id the
 * server assigns in its `start` event.
 *
 * This is a render key, not a security value: it is never trusted by the
 * backend, so it deliberately avoids `crypto.randomUUID()` (which only exists
 * in secure contexts and broke the "Ask" button on non-HTTPS LAN origins).
 * Session/history ids that matter are owned by the edge function.
 */
export function createLocalId(prefix = "t"): string {
  sequence += 1;
  return `${prefix}_${Date.now().toString(36)}_${sequence.toString(36)}`;
}
